import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./TrainingNeedElement.css";

function TrainingNeedElement({ id, name, count }) {
  return (
    <Col key={id} className="training-need-element">
      <Row className="justify-content-center align-items-center">
        <Col lg={10}>
          <h6>{name}</h6>
        </Col>
        <Col lg={2} className="center">
          <p>{count}</p>
        </Col>
      </Row>
    </Col>
  );
}

export default TrainingNeedElement;
